import { valueIsNotNullOrUndefined } from '@afterpay/utils'
import { ErrorCode, isPortalApiError } from '@afterpaytouch/portal-api'
import { OAuthError, OAuthErrorCode, OAuthParams, OAuthResponseType, OAuthScope } from '../model'

const OAUTH_INVALID_REQUEST_ERROR_CODES = [ErrorCode.InvalidObject, ErrorCode.OAuthInvalidRedirectUrl, ErrorCode.InvalidJson]

const OAUTH_UNAUTHORIZED_CLIENT_ERROR_CODES = [
  ErrorCode.OAuthUnregisteredClient,
  ErrorCode.OAuthDisabledClient,
  ErrorCode.OAuthBadCredentials,
  ErrorCode.OAuthInvalidClientId,
  ErrorCode.Unauthorized,
]

export const oAuthErrorQueryParamMapper = (error: OAuthError): OAuthErrorCode | string => {
  if (isPortalApiError(error)) {
    const { errorCode, httpStatusCode } = error
    switch (true) {
      case OAUTH_INVALID_REQUEST_ERROR_CODES.includes(errorCode):
        return OAuthErrorCode.InvalidRequest
      case OAUTH_UNAUTHORIZED_CLIENT_ERROR_CODES.includes(errorCode):
        return OAuthErrorCode.UnauthorizedClient
      case errorCode === ErrorCode.OAuthInvalidGrantType:
        return OAuthErrorCode.UnsupportedResponseType
      case errorCode === ErrorCode.OAuthInvalidScopes:
        return OAuthErrorCode.InvalidScope
      case httpStatusCode === 500:
        return OAuthErrorCode.ServerError
      default:
        return httpStatusCode.toString()
    }
  } else {
    return OAuthErrorCode.AccessDenied
  }
}

export const toOAuthResponseType = (str: string | null): OAuthResponseType => {
  switch (str) {
    case 'code':
      return 'authorization_code'
    case 'refresh_token':
      return str
    default:
      return null
  }
}

export const toOAuthScopeArray = (str: string): OAuthScope[] => {
  return str.split(' ').map((s) => {
    switch (s) {
      case 'read_payment_details':
      case 'read_user_info':
      case 'create_checkout':
        return s
      default:
        return null
    }
  })
}

export const shouldAttemptAccountLink = (oAuth: OAuthParams | undefined): oAuth is Omit<Required<OAuthParams>, 'state'> =>
  valueIsNotNullOrUndefined(oAuth) &&
  valueIsNotNullOrUndefined(oAuth.clientId) &&
  valueIsNotNullOrUndefined(oAuth.responseType) &&
  valueIsNotNullOrUndefined(oAuth.scope) &&
  valueIsNotNullOrUndefined(oAuth.redirectUri)
